import MuiTimeline from "@material-ui/lab/Timeline";
import MuiTimelineConnector from "@material-ui/lab/TimelineConnector";
import MuiTimelineContent from "@material-ui/lab/TimelineContent";
import MuiTimelineDot from "@material-ui/lab/TimelineDot";
import MuiTimelineItem from "@material-ui/lab/TimelineItem";

import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { COLORS } from "constants/colors";
import styled from "styled-components";
import "styled-components/macro";

export const ContainerBadge = styled("div")`
  text-align: -webkit-right;
  .eDzxML {
    background-color: #f2994a;
  }
`;

export const ContainerTaskDetails = styled("div")`
  display: flex;
`;

export const Timeline = styled(MuiTimeline)``;

export const TimelineItem = styled(MuiTimelineItem)`
  min-height: 30px;
  &.dot {
    min-height: 20px;
  }
  :before {
    content: none;
  }
`;

interface AddressPickupProps {
  isPicked?: boolean;
}

export const AddressPickup = styled.div<AddressPickupProps>`
  font-family: Montserrat;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #707070;
  text-decoration: ${({ isPicked }) => (isPicked && "line-through") || "none"};
`;

interface AddressContentProps {
  isDelivery?: boolean;
}

export const AddressContent = styled.div<AddressContentProps>`
  font-family: Montserrat;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #707070;
  text-decoration: ${({ isDelivery }) => (isDelivery && "line-through") || "none"};
`;
export const NameContent = styled.div`
  font-family: Montserrat;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #707070;
`;
export const TimelineContent = styled(MuiTimelineContent)`
  font-size: 14px;
  font-weight: 900;
  color: #707070;
  padding-top: 0px;
  margin-left: -10px;
`;

export const TimelineConnector = styled(MuiTimelineConnector)`
  width: 1px;
  &.dot {
    margin-left: 8px;
  }
`;

export const TimelineDot = styled(MuiTimelineDot)`
  height: 18px;
  width: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
  box-shadow: none;
  margin: 0;
  background-color: transparent;

  &.pickup.outlined {
    color: #399ebf;
    border-color: #399ebf;
  }

  &.pickup.contained {
    background-color: #399ebf;
  }

  &.delivery.outlined {
    color: #ebae23;
    border-color: #ebae23;
  }

  &.delivery.contained {
    background-color: #399ebf;
  }
  &.done {
    color: #c9c9c9;
    border-color: #c9c9c9;
  }

  &.dot {
    height: 6px;
    width: 6px;
    padding: 0;
    margin-bottom: 2px;
    margin-left: 6.75px;
  }
`;
export const useParcelListTaskStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableDetailsTask: {
      margin: "5px -27px 7px -24px",
      " & .MuiTableRow-head": {
        "& .MuiTableCell-head:first-child": {
          paddingLeft: "20px",
          borderBottomLeftRadius: "5px",
          borderTopLeftRadius: "5px",
        },
        "& .MuiTableCell-head:nth-last-child": {
          borderBottomRightRadius: "5px",
          borderTopRightRadius: "5px",
        },
        "& .MuiTableCell-head:last-child": {
          borderBottomRightRadius: "5px",
          borderTopRightRadius: "5px",
          border: "none",
        },
      },
      " & .MuiTableRow-root": {
        "& > td": {
          borderTop: "1px solid rgba(64, 180, 229, 0.25)",
          borderBottom: "1px solid rgba(64, 180, 229, 0.25)",
        },
        "& .MuiTableCell-root:first-child": {
          borderRadius: "5px 0px 0px 5px",
          borderLeft: "5px solid #399EBF",
          padding: "13px",
        },
        "& .MuiTableCell-root:last-child": {
          borderRight: "1px solid rgba(64, 180, 229, 0.25)",
          borderRadius: "0px 5px 5px 0px",
        },
      },
      "& .MuiTableCell-head": {
        marginBottom: "1em",
        height: "40px",
        backgroundColor: COLORS.lightBlue,
        color: COLORS.primary,
      },
      "& .MuiTableRow-head .MuiTableCell-head:first-child": {
        border: "none !important",
      },
      "& .MuiTableRow-root": {
        height: 20,
      },
    },
  })
);
